import { EFinancialStatus } from '../enums/financial-status.enum';

export const financialStatusRecord = {
    [EFinancialStatus.PAID]: 'Pago',
    [EFinancialStatus.PENDING]: 'Pendente',
    [EFinancialStatus.OVERDUE]: 'Atrasado',
};
